import { GetServerSideProps } from 'next'

import ArticlePage from '@/components/Wordpress/ArticlePage/ArticlePage'
import GuidePage from '@/components/Wordpress/GuidePage/GuidePage'
import { getPage, getPost } from '@/services/wordpress.service'
import { PostType } from '@/types/wordpress'
import { ARTICLES_CACHE_CONTROL } from '@/utils/constants'

type Props = {
  enableAdhesion: boolean
  initCountry?: string
  post: PostType
}

const ArticlesSubPage = ({ enableAdhesion, post }: Props) => {
  // For preview mode, which still uses /articles/
  if ((post as PostType).categories?.includes('guide')) {
    return <GuidePage enableAdhesion={enableAdhesion} post={post} />
  }

  return <ArticlePage enableAdhesion={enableAdhesion} post={post} />
}

export const getServerSideProps: GetServerSideProps<Props> = async ({ params, req, res }) => {
  const slug = params!.slug as string

  // First try to get a post
  let post = (await getPost({ slug })) as PostType

  if (!post) {
    // If no post is found, try to get a page
    post = (await getPage({ slug })) as PostType

    if (!post) return { notFound: true }
  } else if (post.categories?.includes('guide')) {
    return {
      redirect: {
        destination: `/guides/${slug}`,
        permanent: true,
      },
    }
  }

  res.setHeader('Cache-Control', ARTICLES_CACHE_CONTROL)

  const props: Props = { enableAdhesion: true, post }
  if (req.headers['cloudfront-viewer-country']) props.initCountry = req.headers['cloudfront-viewer-country'] as string

  return { props }
}

export default ArticlesSubPage
